import { render } from "./NotAllowed.vue?vue&type=template&id=194cda8d"
const script = {}

import exportComponent from "C:\\Dev\\CCERWB\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__